import { Injectable } from '@angular/core';
import { PaginationBuilder, PaginationConfig, PaginationItem, PaginationItemType } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class CustomPaginationBuilder extends PaginationBuilder {

  /**
   * Builds a list of `PaginationItem`. The give pageCount and current are used
   * to build out the full pagination. There are various {@link PaginationConfig} options
   * which can be used to configure the behavior of the build. Alternatively, CSS
   * can be used to further specialize visibility of the pagination.
   *
   * @param pageCount The total number of pages
   * @param current The current page number, 0-index based
   * @returns An array of `PaginationItem`
   */
  paginate(pageCount: number, current: number): PaginationItem[] {
    const pages: PaginationItem[] = [];
    if (!pageCount || pageCount < 2) {
      return pages;
    }
    this.addPages(pages, pageCount, current);
    this.addDots(pages, pageCount);
    this.addFirstLast(pages, pageCount);
    this.addNavigation(pages, pageCount, current);
    this.addPageConnectors(pages);

    return pages;
  }

  addPageConnectors(
    pages: PaginationItem[]
  ): void {
    const connector = {
      number: null,
      label: "-",
      type: PaginationItemType.GAP,
    };
    let length = pages.length;
    for (let i = 0; i < length; i++) {
      if (!pages[i + 1]) {
        break;
      }
      const page = pages[i];
      const nextPage = pages[i + 1];
      if (page.type === PaginationItemType.PAGE && nextPage) {
        if (nextPage.type === PaginationItemType.PAGE || nextPage.type === PaginationItemType.LAST) {
          pages.splice(i + 1, 0, connector);
          length = length + 1;
        }
      } else if (page.type === PaginationItemType.FIRST && nextPage) {
        if (nextPage.type === PaginationItemType.PAGE) {
          pages.splice(i + 1, 0, connector);
          length = length + 1;
        }
      }
    }
  };
}
